const API_URL =
  process.env.REACT_APP_API_URL;

/**
 * ✅ Central token reader.
 * Login saves to sessionStorage; legacy code uses localStorage.
 * This helper checks sessionStorage first so both paths work,
 * including Safari on iPhone/Mac where sessionStorage is per-tab.
 */
const getToken = () =>
  sessionStorage.getItem("Token") || localStorage.getItem("Token") || null;

const clearStorageKeepEod = () => {
  // Backup eodChecked and opening_cash keys from localStorage
  const backup = {};
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    if (key && (key.startsWith("eodChecked_") || key.startsWith("opening_cash_"))) {
      backup[key] = localStorage.getItem(key);
    }
  }

  // Clear storage
  localStorage.clear();
  sessionStorage.clear();

  // Restore backed up keys
  Object.keys(backup).forEach(key => {
    localStorage.setItem(key, backup[key]);
  });
};

export const getParsedPaymentMethods = (invoice) => {
    if (!invoice) return [];

    let methods = [];

    // 1. Service Wallet
    let serviceWalletAmount = 0;
    if (Array.isArray(invoice.items)) {
        invoice.items.forEach(item => {
            if (item.isServiceWalletApplied || item.customerWalletId || item.serviceWalletName) {
                const qty = Number(item.qty || 1);
                const unitPrice = Number(item.unitPriceOriginal || item.price || item.total || 0);
                serviceWalletAmount += (qty * unitPrice);
            }
        });
    }

    if (serviceWalletAmount > 0) {
        methods.push({ method: "SERVICE WALLET", amount: serviceWalletAmount });
    }

    // 2. Cash Wallet
    let cashWalletAmount = Number(invoice.cashWalletDeduction || 0);
    
    // Sometimes cash wallet deduction is stored in appliedWallets
    if (cashWalletAmount === 0 && Array.isArray(invoice.appliedWallets)) {
        const cashApplied = invoice.appliedWallets.find(w => w.type === 'Cash' || w.walletType === 'Cash');
        if (cashApplied) {
            cashWalletAmount = Number(cashApplied.amountUsed || 0);
        }
    }

    // Check paymentMode for generic "WALLET" which means Cash Wallet
    let hasWalletInPaymentMode = false;
    let paymentModeWalletAmount = 0;
    if (Array.isArray(invoice.paymentMode)) {
        const pWallet = invoice.paymentMode.find(p => p.method?.toUpperCase() === 'WALLET');
        if (pWallet) {
            hasWalletInPaymentMode = true;
            paymentModeWalletAmount = Number(pWallet.amount || 0);
        }
    } else if (invoice.paymentMode && typeof invoice.paymentMode === 'object' && invoice.paymentMode.method?.toUpperCase() === 'WALLET') {
        hasWalletInPaymentMode = true;
        paymentModeWalletAmount = Number(invoice.paymentMode.amount || 0);
    }
    
    if (cashWalletAmount === 0 && hasWalletInPaymentMode) {
        cashWalletAmount = paymentModeWalletAmount;
    }

    if (cashWalletAmount > 0) {
        methods.push({ method: "CASH WALLET", amount: cashWalletAmount });
    }

    // 3. Normal Payments
    if (Array.isArray(invoice.paymentMode)) {
        invoice.paymentMode.forEach(p => {
            if (p.method && p.method.toUpperCase() !== 'WALLET') {
                const method = p.method.toUpperCase();
                const amt = Number(p.amount || 0);
                if (amt > 0) {
                    const existing = methods.find(m => m.method === method);
                    if (existing) {
                        existing.amount += amt;
                    } else {
                        methods.push({ method, amount: amt, cardNumber: p.cardNumber });
                    }
                }
            }
        });
    } else if (invoice.paymentMode && typeof invoice.paymentMode === 'object' && invoice.paymentMode.method) {
        if (invoice.paymentMode.method.toUpperCase() !== 'WALLET') {
            const method = invoice.paymentMode.method.toUpperCase();
            const amt = Number(invoice.paymentMode.amount || 0);
            if (amt > 0) {
                methods.push({ method, amount: amt, cardNumber: invoice.paymentMode.cardNumber });
            }
        }
    }

    // Fallback if empty
    if (methods.length === 0) {
        const total = Number(invoice.grandTotal || 0);
        if (total >= 0) {
            methods.push({ method: "CASH", amount: total });
        }
    }

    return methods;
};

export const getPaymentMethodBreakdowns = (invoice) => {
    return getParsedPaymentMethods(invoice).map(m => {
        if (m.method === 'SERVICE WALLET') {
            return m.method;
        }
        return `${m.method} - ₹${m.amount.toFixed(2)}`;
    });
};

export { API_URL, getToken, clearStorageKeepEod };